import { useState } from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";
import { putRegion } from "../../controllers/org";
import Loading from "../loading/Loading";
import { useAuth } from "../auth/AuthProvider";

function CrearRegion({ onSuccess }) {
  const [nombreRegion, setNombreRegion] = useState('');
  const [checkedValues, setCheckedValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState();
  const { token } = useAuth();

  // const options = [
  //   { id: 'opt1', label: 'Option 1', value: 'value1' },
  //   { id: 'opt2', label: 'Option 2', value: 'value2' },
  //   { id: 'opt3', label: 'Option 3', value: 'value3' },
  // ];

  async function submit(e) {
    e.preventDefault();
    console.log(e);
    setIsLoading(true);
    let a;
    try {
      const r = await putRegion(nombreRegion, token);
      a = <Alert key='alert' variant='success' dismissible>Se creó la región <b>{nombreRegion}</b> con éxito.</Alert>;

      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    }
    catch (e) {
      a = <Alert key='alert' variant='danger' dismissible>Error al crear región. Por favor intenta más tarde.</Alert>;
    }
    setIsLoading(false);
    if (a) {
      setAlert(a);
    }
  }

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    if (checked) {
      setCheckedValues((prevCheckedValues) => [...prevCheckedValues, value]);
    } else {
      setCheckedValues((prevCheckedValues) =>
        prevCheckedValues.filter((item) => item !== value)
      );
    }
  };

  if (isLoading) {
    return <Card>
      <Card.Header>Crear Región</Card.Header>
      <Card.Body><Loading text="Creando región..." /></Card.Body>
    </Card>
  }

  return <Card>
    <Card.Header>Crear Región</Card.Header>
    <Card.Body>
      { alert }
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Nombre de la región</Form.Label>
          <Form.Control type="text" placeholder="Región" value={nombreRegion} onChange={e => setNombreRegion(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mb-3 submit-buttons-wrapper">
          <Button key='submit-btn-new-region' type='submit' variant='primary' onClick={submit}>Guardar región</Button>
        </Form.Group>
      </Form>
    </Card.Body>
  </Card>
}

export default CrearRegion;
